import { z } from 'zod';

/**
 * Check-in Methode Enum.
 */
export const CheckInMethodSchema = z.enum(['qr', 'manual']);

/** TypeScript Type für Check-in Methode */
export type CheckInMethod = z.infer<typeof CheckInMethodSchema>;

/**
 * Zod Schema für CheckIn — Runtime-Validierung + Type-Inference.
 * QR-Scan oder manueller Check-in für alle Kategorien.
 */
export const CheckInSchema = z.object({
  id: z.string().cuid(),
  eventId: z.string().cuid(),
  userId: z.string(),
  method: CheckInMethodSchema.default('qr'),
  checkedInBy: z.string().nullable().optional(), // User ID des Scanners
  checkedInAt: z.coerce.date(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type CheckIn = z.infer<typeof CheckInSchema>;

/**
 * Schema für CheckIn-Erstellung.
 * Entweder `userId` (manueller Check-in) oder `barcode` (QR-Scan via pdfDriveId) muss angegeben werden.
 */
export const CreateCheckInSchema = z
  .object({
    eventId: z.string(),
    userId: z.string().optional(),
    barcode: z.string().optional(),
    method: CheckInMethodSchema.default('qr'),
    checkedInBy: z.string().nullable().optional(),
  })
  .refine((data) => data.userId !== undefined || data.barcode !== undefined, {
    message: 'userId oder barcode muss angegeben werden',
  });

/** TypeScript Type für CheckIn-Erstellung */
export type CreateCheckIn = z.infer<typeof CreateCheckInSchema>;

/**
 * Schema für CheckIn-Update.
 * Nur method und checkedInBy sind aktualisierbar.
 */
export const UpdateCheckInSchema = CheckInSchema.pick({
  method: true,
  checkedInBy: true,
}).partial();

/** TypeScript Type für CheckIn-Update */
export type UpdateCheckIn = z.infer<typeof UpdateCheckInSchema>;
